module.exports = __webpack_public_path__ + "static/media/message-background.a9778de6.png";